export default "__VITE_ASSET__62fe346e__"